<template>
  <div id="brand-example" class="brand-example">
    <h3 v-if="headline">{{ headline }}</h3>
    <div class="contents">
      <div class="image">
        <img :src="loadImg(img)" >
      </div>
      <div class="text" v-if="okHeadline || ngHeadline">
        <ul>
          <li v-if="okHeadline" class="ok">
            <h5><img src="@/assets/images/icon-ok.svg" alt="OK"><span>{{ okHeadline }}</span></h5>
            <slot name="okDescreption"></slot>
          </li>
          <li v-if="ngHeadline" class="ng">
            <h5><img src="@/assets/images/icon-ng.svg" alt="NG"><span>{{ ngHeadline }}</span></h5>
            <slot name="ngDescreption"></slot>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandExample',
  props: {
    headline: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    },
    okHeadline: {
      type: String,
      default: ''
    },
    ngHeadline: {
      type: String,
      default: ''
    }
  },
  methods: {
    loadImg: function (srcPath) {
      let image = require.context('@/assets/images', false, /\.png$|\.jpg$|\.svg$/)
      return image('./' + srcPath)
    }
  }
}
</script>

<style scoped>
.brand-example {
  margin-bottom: 3.2rem;
}

h3 {
  font-size: var(--large-font-size);
  font-weight: var(--bolder-font-weight);
  line-height: 1.777778;
  margin-bottom: 1.6rem;
  color: var(--dark-gray);
  text-align: left;
}

.contents {
  background: var(--white);
  border-radius: 0.8rem;
  border: solid var(--light-gray) 0.1rem;
  overflow: hidden;
}

.image img {
  width: 100%;
  height: auto;
  vertical-align: middle;
}

.text {
  border-top: solid var(--light-gray) 0.1rem;
  padding: 2.4rem 3.2rem;
  text-align: left;
}

h5 {
  font-size: var(--normal-font-size);
  font-weight: var(--bolder-font-weight);
  line-height: 1.5;
}

.ok h5 {
  color: var(--novasell-green);
}

.ng h5 {
  color: var(--bitter-sweet);
}

h5 img {
  width: 2.4rem;
  height: auto;
  margin-right: 0.8rem;
  vertical-align: middle;
}

h5 span {
  vertical-align: middle;
}

.text p {
  font-size: var(--small-font-size);
  line-height: 2;
  color: var(--davys-gray);
  margin-top: 0.8rem;
  margin-bottom: 0;
  letter-spacing: 0;
}

ul {
  display: flex;
}
li {
  flex: 1;
}
li+li {
  margin-left: 3.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Molecules/BrandExample.vue